import React, { useState } from "react";
import "../Css/header2.css";
import { NavLink, Link } from "react-router-dom";
import { TiThMenu } from "react-icons/ti";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Logo from "../Img/Brand-logo.png";
import ACSApplicationFrom from "../pdf/ACS-Application-Form.docx";

const Header2 = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav>
        <div className="wrapper-nav">
          <div className="logo">
            <Link to="/" onClick={handleLinkClick}>
              <img src={Logo} className="logo-head" alt="logo" />
            </Link>
          </div>

          <input
            type="checkbox"
            id="menu-btn"
            checked={isMenuOpen}
            onChange={() => setIsMenuOpen(!isMenuOpen)}
          />

          <input type="radio" name="slider" id="close-btn" />

          <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            <label htmlFor="close-btn" className="btn close-btn">
              <IoIosCloseCircleOutline
                onClick={handleLinkClick}
                className="v-close"
              />
            </label>

            <li>
              <NavLink
                to="/"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Home
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/about"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                About Affinity
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/ourapproch"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Our Approach
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/ourhome"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Our Homes
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/safeguardingquality"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Safeguarding & Quality
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/referrals"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Referrals
              </NavLink>
            </li>
            {/* Heading 
            <li>
              <NavLink
                to="/careers"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Careers
              </NavLink>
            </li>*/}
            <li>
              <NavLink
                to="/careers"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Career
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/contact"
                onClick={handleLinkClick}
                className={({ isActive }) => (isActive ? "active-tab" : "")}
              >
                Contact
              </NavLink>
            </li>
            <li className="nav-item">
              <a
                href={ACSApplicationFrom}
                download="ACS-Application-Form.docx"
                onClick={handleLinkClick}
              >
                Download Form
              </a>
            </li>
          </ul>

          <label htmlFor="menu-btn" className="btn menu-btn">
            <TiThMenu className="menu-ic" />
          </label>
        </div>
      </nav>
    </>
  );
};

export default Header2;
